import { businessStore, dayCalendarStore } from 'entities/index';
import React, { useEffect, useState } from 'react';
import { useWeeklyCalendar } from 'shared/hooks';
import styles from './day-calendar.page.module.scss';
import { MiniWeeklyCalendar } from 'features/mini-weekly-calendar/ui/mini-weekly-calendar';
import { DayCalendar } from 'features/day-calendar/ui/day-calendar';
import { observer } from 'mobx-react';

export const DayCalendarPage: React.FC = observer(() => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const pointId = localStorage.getItem('pointId');
  const [microSlotDuration, setMicroSlotDuration] = useState<number>(() => {
    const saved = localStorage.getItem('microSlotDuration');
    return saved ? parseInt(saved) : 15;
  });

  useEffect(() => {
    localStorage.setItem('microSlotDuration', microSlotDuration.toString());
  }, [microSlotDuration]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (pointId) {
      if (!businessStore.pointHeaderData) {
        businessStore.initPointHeaderData(pointId);
      }
      if (!businessStore.servicesList) {
        businessStore.initServicesList(pointId);
      }
      if (!businessStore.serviceCategories) {
        businessStore.initServiceCategories(pointId);
      }
    }
  }, [pointId]);

  const date = dayCalendarStore.getSelectedDateAsDate;
  const { selectedDate, week, changeWeekHandler, selectedDateHandler } =
    useWeeklyCalendar(date, pointId || undefined);

  if (!pointId) {
    return <div>Загрузка...</div>;
  }
  return (
    <div className={styles.day_calendar__container}>
      <div className={styles.day_calendar__modal_container}>
        {!isMobile && (
          <div className={styles.content__header}>
            <MiniWeeklyCalendar
              date={selectedDate}
              dateChangeHandler={selectedDateHandler}
              week={week}
              changeWeekHandler={changeWeekHandler}
              microSlotDuration={microSlotDuration}
              setMicroSlotDuration={setMicroSlotDuration}
              isMobile={isMobile}
            />
          </div>
        )}
        <div className={styles.content__body}>
          <DayCalendar
            date={selectedDate}
            microSlotDuration={microSlotDuration}
          />
          {isMobile && (
            <div className={styles.mobile__week}>
              <MiniWeeklyCalendar
                date={selectedDate}
                dateChangeHandler={selectedDateHandler}
                week={week}
                changeWeekHandler={changeWeekHandler}
                microSlotDuration={microSlotDuration}
                setMicroSlotDuration={setMicroSlotDuration}
                isMobile={isMobile}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
});
